'use client';

import type { ComponentProps } from 'react';

import { cn } from '@kit/ui/utils';

import { useNativePresentation } from '../_lib/use-native-presentation';
import styles from '../native-presentation.module.css';

export function NativeContentSurface({
  children,
  className,
  style,
  ...props
}: ComponentProps<'div'>) {
  const presentation = useNativePresentation();
  return (
    <div
      {...props}
      className={cn(
        className,
        presentation.className,
        presentation.className && styles.content,
      )}
      style={{ ...style, ...presentation.style }}
    >
      {children}
    </div>
  );
}
